import * as React from "react";
import { useEffect } from "react";
import { Coffee, UtensilsCrossed, ShoppingBag } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
const categories = [{
  id: "breakfast-pastries",
  name: "Breakfast",
  icon: <UtensilsCrossed className="size-5" />
}, {
  id: "deli-sandwiches",
  name: "Lunch",
  icon: <UtensilsCrossed className="size-5" />
}, {
  id: "drinks",
  name: "Coffee & Drinks",
  icon: <Coffee className="size-5" />
}, {
  id: "market-seasonal",
  name: "Bakery & Salads",
  icon: <ShoppingBag className="size-5" />
}];
const menuItems = [
// Breakfast
{
  id: 1,
  categoryId: "breakfast-pastries",
  name: "M&M Classic",
  description: "Egg & Cheddar",
  price: "",
  isChefsChoice: false
}, {
  id: 2,
  categoryId: "breakfast-pastries",
  name: "M&M Premium",
  description: "Egg, Cheddar, Arugula, Tomato",
  price: "",
  isChefsChoice: false
}, {
  id: 3,
  categoryId: "breakfast-pastries",
  name: "M&M Garlic",
  description: "Egg, Cheddar, Arugula, Tomato, Garlic Aioli",
  price: "",
  isChefsChoice: false
}, {
  id: 4,
  categoryId: "breakfast-pastries",
  name: "M&M Spicy",
  description: "Egg, Cheddar, Arugula, Tomato, Spicy Aioli",
  price: "",
  isChefsChoice: false
}, {
  id: 5,
  categoryId: "breakfast-pastries",
  name: "M&M Turkey",
  description: "Turkey, Egg, Cheddar, Arugula, Tomato, Garlic Aioli or Spicy Aioli",
  price: "",
  isChefsChoice: false
}, {
  id: 6,
  categoryId: "breakfast-pastries",
  name: "M&M Ham",
  description: "Ham, Egg, Cheddar, Arugula, Tomato, Garlic Aioli or Spicy Aioli",
  price: "",
  isChefsChoice: false
}, {
  id: 7,
  categoryId: "breakfast-pastries",
  name: "M&M Spinach Tomato",
  description: "Spinach, Tomato, Egg, Cheddar, Garlic Aioli or Spicy Aioli",
  price: "",
  isChefsChoice: false
},
// Lunch
{
  id: 7,
  categoryId: "deli-sandwiches",
  name: "Ham Pesto",
  description: "Served on Focaccia (large) or Ciabatta (small).",
  price: "",
  isChefsChoice: false
}, {
  id: 8,
  categoryId: "deli-sandwiches",
  name: "Turkey Pesto",
  description: "Served on Focaccia (large) or Ciabatta (small).",
  price: "",
  isChefsChoice: false
}, {
  id: 9,
  categoryId: "deli-sandwiches",
  name: "Italian Deli",
  description: "Served on Focaccia (large) or Ciabatta (small).",
  price: "",
  isChefsChoice: false
}, {
  id: 10,
  categoryId: "deli-sandwiches",
  name: "Caprese",
  description: "Served on Focaccia (large) or Ciabatta (small).",
  price: "",
  isChefsChoice: false
}, {
  id: 11,
  categoryId: "deli-sandwiches",
  name: "Vegetarian",
  description: "Served on Focaccia (large) or Ciabatta (small).",
  price: "",
  isChefsChoice: false
},
// Coffee & Drinks
{
  id: 12,
  categoryId: "drinks",
  name: "Coffee: Drip Coffee",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 13,
  categoryId: "drinks",
  name: "Coffee: Espresso",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 14,
  categoryId: "drinks",
  name: "Coffee: Americano",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 15,
  categoryId: "drinks",
  name: "Coffee: Cappuccino",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 16,
  categoryId: "drinks",
  name: "Coffee: Machiato",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 17,
  categoryId: "drinks",
  name: "Latte: Vanilla",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 18,
  categoryId: "drinks",
  name: "Latte: Carmel",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 19,
  categoryId: "drinks",
  name: "Latte: Mocha",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 20,
  categoryId: "drinks",
  name: "Latte: Honey Cinnamon",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 21,
  categoryId: "drinks",
  name: "Latte: Banana Bread",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 22,
  categoryId: "drinks",
  name: "Latte: Dot Cake",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 23,
  categoryId: "drinks",
  name: "Latte: Carrot Cake",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 24,
  categoryId: "drinks",
  name: "Latte: S'mores",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 25,
  categoryId: "drinks",
  name: "Latte: Chai",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 26,
  categoryId: "drinks",
  name: "Matcha: Matcha Latte",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 27,
  categoryId: "drinks",
  name: "Matcha: Strawberry",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 28,
  categoryId: "drinks",
  name: "Matcha: Banana",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 29,
  categoryId: "drinks",
  name: "Matcha: Blueberry",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 30,
  categoryId: "drinks",
  name: "Add-On: Extra Espresso Shot",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 31,
  categoryId: "drinks",
  name: "Add-On: Cold Foam",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 32,
  categoryId: "drinks",
  name: "Add-On: Alternative Milk",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 33,
  categoryId: "drinks",
  name: "Add-On: Flavor Shot",
  description: "",
  price: "",
  isChefsChoice: false
},
// Bakery & Salads
{
  id: 34,
  categoryId: "market-seasonal",
  name: "Croissant",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 35,
  categoryId: "market-seasonal",
  name: "Chocolate Cookie Croissant",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 36,
  categoryId: "market-seasonal",
  name: "Cinnamon Roll",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 37,
  categoryId: "market-seasonal",
  name: "Danish",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 38,
  categoryId: "market-seasonal",
  name: "Donut",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 39,
  categoryId: "market-seasonal",
  name: "Bagel w/ Cream Cheese",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 40,
  categoryId: "market-seasonal",
  name: "Strawberry Goat Cheese Salad",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 41,
  categoryId: "market-seasonal",
  name: "Greek Salad",
  description: "",
  price: "",
  isChefsChoice: false
}, {
  id: 42,
  categoryId: "market-seasonal",
  name: "Caesar Salad",
  description: "",
  price: "",
  isChefsChoice: false
}];
export default function FromOurKitchen() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }
  }, []);
  return <section data-section-id="241192" id="from-our-kitchen" className="bg-background text-foreground relative w-full scroll-smooth">
      {/* Category Quick Navigation */}
      <div className="sticky top-0 z-40 w-full bg-background/90 backdrop-blur-lg border-b border-border/50">
        <div className="container mx-auto px-4">
          <nav className="flex flex-wrap items-center justify-start md:justify-center gap-4 md:gap-6 overflow-x-auto py-5 p-2 no-scrollbar">
            {categories.map((cat, i) => <div key={cat.id} data-index={i}>
                <Link to={`#${cat.id}`} className="group flex items-center gap-2 text-lg font-sans font-semibold text-muted-foreground hover:text-primary whitespace-nowrap transition-colors duration-200 tracking-wide bg-primary/10 rounded-lg px-4 py-2 cursor-pointer">
                  <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-secondary">
                    {cat.icon}
                  </span>
                  {cat.name}
                </Link>
              </div>)}
          </nav>
        </div>
      </div>

      {/* Main Menu Content */}
      <div className="container mx-auto px-4 py-16 md:py-24">
        <div className="max-w-6xl mx-auto space-y-32">
          {categories.map((category, i) => <div key={category.id} id={category.id} data-index={i} className="scroll-mt-32">
              {/* Category Header with Icon Treatment */}
              <div className="mb-16 text-center">
                <div className="relative w-full h-64 md:h-96 mb-10 overflow-hidden rounded-2xl shadow-lg bg-gradient-to-br from-secondary/15 via-accent/30 to-background border border-border/60 flex flex-col items-center justify-center p-6 md:p-12 group">
                  <div className="mb-4 md:mb-6 flex items-center justify-center size-20 md:size-28 rounded-2xl bg-secondary/10 border border-secondary/20 text-secondary shadow-sm transition-transform duration-300 group-hover:scale-105">
                    {category.id === "drinks" ? <Coffee className="size-10 md:size-14 stroke-[1.5]" /> : category.id === "market-seasonal" ? <ShoppingBag className="size-10 md:size-14 stroke-[1.5]" /> : <UtensilsCrossed className="size-10 md:size-14 stroke-[1.5]" />}
                  </div>
                  <h2 className="text-5xl md:text-7xl font-serif font-medium text-foreground tracking-tight">
                    {category.name}
                  </h2>
                </div>
              </div>

              {category.id === "breakfast-pastries" && <p className="text-center font-sans text-sm md:text-base text-muted-foreground mb-12 -mt-6 max-w-2xl mx-auto">
                  All sandwiches are served on your choice of Plain or Everything Bagel. Choose Garlic Aioli or Spicy Aioli where offered.
                </p>}

              {/* Menu Items Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-12">
                {menuItems.filter(item => item.categoryId === category.id).map((item, j) => <div key={item.id} data-index={j} className="flex flex-col group">
                      <div className="flex justify-between items-baseline mb-3 gap-4">
                        <h3 className="font-serif font-semibold text-2xl md:text-3xl text-foreground group-hover:text-secondary transition-colors duration-300">
                          {item.name}
                          {item.isChefsChoice && <span className="ml-2 inline-block size-2 rounded-lg bg-secondary align-middle" title="Seasonal Selection" />}
                        </h3>
                        {item.price && <span className="font-mono text-lg text-muted-foreground">
                            {item.price}
                          </span>}
                      </div>
                      {item.description && <p className="font-sans text-base md:text-lg text-muted-foreground/90 leading-relaxed mb-6">
                          {item.description}
                        </p>}
                      <Separator className="bg-border/40" />
                    </div>)}
              </div>
            </div>)}
        </div>

        {/* Advisory / Disclaimer Note */}
        <div className="max-w-4xl mx-auto mt-32 p-8 md:p-12 bg-accent/30 rounded-2xl border border-border/50">
          <div className="space-y-6 text-sm md:text-base text-muted-foreground/80 font-sans leading-relaxed italic">
            <p>
              Bread and pastries are purchased from approved commercial vendors. No bread or pastry baking is performed onsite.
            </p>
            <p>
              <span className="font-semibold text-foreground not-italic">Consumer Advisory:</span> Menu items marked with * contain animal foods such as eggs, bacon, or sausage. Eggs are cooked to order and breakfast meats are precooked and heated for service. Consuming raw or undercooked meats, poultry, seafood, shellfish, or eggs may increase your risk of foodborne illness.
            </p>
          </div>
        </div>
      </div>
    </section>;
}